const NotFound: React.FC<{}> = () => (
  <p className="text-center text-xl text-gray_3">Página não encontrada.</p>
);

export default NotFound;
